window.theme ??= {};

window.theme.CART_WEB_LOCK_KEY ??= 'shopify-cart-api';

window.theme.withCartApiLock ??= (task) => {
  if (!globalThis.navigator?.locks?.request) {
    return task();
  }

  return globalThis.navigator.locks.request(window.theme.CART_WEB_LOCK_KEY, () => task());
};

window.theme.CartService ??= class CartService {
  static get #base() {
    return `${window.Shopify.routes.root}cart`;
  }

  static async #get(url) {
    return window.theme.withCartApiLock(() => fetch(url).then((response) => response.json()));
  }

  static async #post(url, body) {
    const isFormData = body instanceof FormData;

    return window.theme.withCartApiLock(() => fetch(url, {
      method: 'POST',
      ...(isFormData ? {} : { headers: { 'Content-Type': 'application/json' } }),
      body: isFormData ? body : JSON.stringify(body),
    }).then((response) => response.json()));
  }

  static getCart() {
    return this.#get(`${this.#base}.js`);
  }

  static getWithSections(sections) {
    return this.#get(`${this.#base}?sections=${sections}`);
  }

  static add(data) {
    return this.#post(`${this.#base}/add.js`, data);
  }

  static change(data) {
    return this.#post(`${this.#base}/change.js`, data);
  }

  static update(data) {
    return this.#post(`${this.#base}/update.js`, data);
  }

  static clear() {
    return this.#get(`${this.#base}/clear.js`);
  }
};

document.dispatchEvent(new CustomEvent('theme:cart-service:ready'));